<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/ata-rangi')">Ata Rangi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/bell-hill-vineyards')">Bell Hill Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/craggy-range')">Craggy Range
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/dog-point-vineyards')">Dog Point Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/new-zealand/millton-vineyards-and-winery')">Millton
                        Vineyards and Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/pyramid-valley-vineyards')">Pyramid Valley
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/rippon-vineyards')">Rippon Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/trinity-hill')">Trinity Hill
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Millton Vineyards and Winery</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Se hai mai visitato la Nuova Zelanda, capirai la grandiosità, il potenziale e
                        la vasta portata della sua regione vinicola. Nuovi vini sono spuntati dappertutto, eppure alcuni,
                        come Millton, sono stati determinanti nello stabilire quello che noi consideriamo il vino della Nuova Zelanda
                        “industria” oggi.
                    </div>

                    <div class="howto-title2">Imparare a volare dai migliori</div>
                    <div class="howto-text">
                        Situato nella splendida regione di Gisborne, sulle rive del fiume Te Arai, Millton afferma con orgoglio di essere il primo vigneto a praticare l'agricoltura biologica e biodinamica nel paese. Fondato nel 1984, James e Annie Millton non hanno bisogno di presentazioni. Il padre di Annie, John Clark,
                        è stato un precursore nella creazione di vigneti in Nuova Zelanda, avendo piantato viti fin dal
                        1967. Da giovane coppia, James e Annie si recarono in Europa per fare esperienza nel
                        business, facendosi le ossa in tenute prestigiose come Champagne Bollinger, Maison Sichel
                        a Bordeaux e Weingut Kurstner nell'Assia Renana. Al loro ritorno in Nuova Zelanda, ne hanno ripiantato gran parte
                        La tenuta di Clark (che all'epoca era più un'attività di viticoltura) e, presto, Millton
                        Nasce Vigne e Cantina.
                    </div>

                    <div class="howto-title2">Quattro etichette</div>
                    <div class="howto-text">
                        Dall'inizio di Milton, i Millton hanno piantato altri due vigneti e oggi producono
                        vitigni di Chardonnay, Pinot Noir, Syrah, Gewurztraminer e Riesling sotto quattro etichette principali.
                        Di questi, la loro gamma firmata Millton è la migliore espressione dei loro quarant'anni di
                        evoluzione, e sia il Pinot Noir che il Reisling sono i punteggi più alti con 90 punti complessivi
                        in generale (93 da Huon Hook per il Pinot Noir del 2011). Come con la maggior parte dei vini del nuovo mondo, il prezzo è
                        ridicolmente basso, pensa solo € 20 in media.
                        <br><br>
                        Mentre investire in vini pregiati del nuovo mondo rimane per ora una sorta di zona grigia, Millton's
                        il patrimonio, il savoir-faire, le pratiche agricole e le basse rese contribuiscono notevolmente a collocarli al
                        in cima alla lista quando è il momento giusto. Che potrebbe essere anche adesso.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Millton Vineyards and Winery</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wenn Sie Neuseeland jemals besucht haben, werden Sie die Größe, das Potenzial und das Potenzial verstehen
                        die Weite seiner Weinregion. Überall tauchen neue Weine auf, doch einige,
                        wie Millton, waren maßgeblich daran beteiligt, das zu etablieren, was wir als neuseeländischen Wein bezeichnen
                        „Industrie“ heute.
                    </div>

                    <div class="howto-title2">Von den Besten das Fliegen lernen</div>
                    <div class="howto-text">
                        Millton liegt in der atemberaubenden Region Gisborne am Ufer des Flusses Te Arai und ist stolz darauf, dass es das erste Weingut des Landes ist, das biologischen und biodynamischen Landbau betreibt. James und Annie Millton wurden 1984 gegründet und bedürfen keiner Vorstellung. Annies Vater, John Clark,
                        war ein Vorreiter bei der Errichtung von Weinbergen in Neuseeland und pflanzte bereits Weinreben
                        1967. Als junges Paar reisten James und Annie nach Europa, um dort Erfahrungen zu sammeln
                        Unternehmen und haben sich in prestigeträchtigen Weingütern wie Champagne Bollinger und Maison Sichel einen Namen gemacht
                        in Bordeaux und Weingut Kurstner in Rheinhessen. Nach ihrer Rückkehr nach Neuseeland pflanzten sie einen Großteil davon neu an
                        Clarks Anwesen (das zu dieser Zeit eher ein Weinanbaubetrieb war) und schwupps, Millton
                        Vineyards and Winery war geboren.
                    </div>

                    <div class="howto-title2">Vier Beschriftungen</div>
                    <div class="howto-text">
                        Seit der Gründung von Milton haben die Milltons zwei weitere Weinberge angelegt und produzieren heute
                        Rebsorten Chardonnay, Pinot Noir, Syrah, Gewürztraminer und Riesling unter vier Hauptetiketten.
                        Von diesen ist ihr charakteristisches Millton-Sortiment der beste Ausdruck ihrer vierzigjährigen Erfahrung
                        Evolution, und sowohl der Pinot Noir als auch der Reisling sind mit insgesamt 90 Punkten Spitzenreiter
                        im Allgemeinen (93 von Huon Hook für den Pinot Noir 2011). Wie bei den meisten Weinen aus der Neuen Welt gelten auch hier die Preise
                        lächerlich niedrig, durchschnittlich nur 20 €.
                        <br><br>
                        Während Investitionen in erlesene Weine aus der neuen Welt vorerst noch eine Art Grauzone bleiben, sagt Millton’s
                        Erbe, Savoir-faire, landwirtschaftliche Praktiken und niedrige Erträge tragen wesentlich dazu bei, dass sie an der Spitze stehen
                        ganz oben auf der Liste, wenn der richtige Zeitpunkt gekommen ist. Was auch jetzt noch der Fall sein könnte.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Millton Vineyards and Winery</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Si vous avez déjà visité la Nouvelle-Zélande, alors vous comprendrez la grandeur, le potentiel et
                        l'immensité de sa région viticole. De nouveaux vins ont surgi un peu partout, mais certains,
                        comme Millton, ont joué un rôle déterminant dans l'établissement de ce que nous considérons comme le vin néo-zélandais
                        "l'industrie" aujourd'hui.
                    </div>

                    <div class="howto-title2">Apprendre à voler avec les meilleurs</div>
                    <div class="howto-text">
                        Situé dans la magnifique région de Gisborne, sur les rives de la rivière Te Arai, Millton déclare fièrement qu'il s'agit du premier vignoble à pratiquer l'agriculture biologique et biodynamique dans le pays. Fondés en 1984, James et Annie Millton n'ont plus besoin d'être présentés. Le père d'Annie, John Clark,
                        a été un précurseur dans l'établissement de vignobles en Nouvelle-Zélande, ayant planté des vignes dès
                        1967. En tant que jeune couple, James et Annie se sont rendus en Europe pour acquérir de l'expérience dans le
                        entreprise, se faisant les dents dans des domaines prestigieux tels que Champagne Bollinger, Maison Sichel
                        à Bordeaux et Weingut Kurstner en Rheinhessen. À leur retour en Nouvelle-Zélande, ils ont replanté une grande partie de
                        Le domaine de Clark (qui était plus une entreprise viticole à l'époque), et hop, Millton
                        Vignobles et Chai est né.
                    </div>

                    <div class="howto-title2">Quatre étiquettes</div>
                    <div class="howto-text">
                        Depuis la création de Milton, les Millton ont planté deux autres vignobles et aujourd'hui ils produisent
                        cépages de Chardonnay, Pinot Noir, Syrah, Gewurztraminer et Riesling sous quatre étiquettes principales.
                        Parmi celles-ci, leur gamme signature Millton est la meilleure expression de leurs quarante années de
                        l'évolution, et le Pinot Noir et le Reisling sont de bons scores à 90 points au total
                        en général (93 de Huon Hook pour le Pinot Noir 2011). Comme pour la plupart des vins du nouveau monde, le prix est
                        ridiculement bas, pensez à seulement 20 € en moyenne.
                        <br><br>
                        Alors que l'investissement dans les vins fins du nouveau monde reste une zone grise pour l'instant, Millton's
                        patrimoine, savoir-faire, pratiques agricoles et faibles rendements contribuent à les placer au
                        haut de la liste quand le moment est venu. Ce qui pourrait être encore maintenant.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Millton Vineyards and Winery</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        If you have ever visited New Zealand, then you will understand the grandeur, the potential and
                        the vast scope of its wine region. New wines have been popping up all over the place, yet some,
                        such as Millton, have been instrumental in establishing what we consider the New Zealand wine
                        “industry” today.
                    </div>

                    <div class="howto-title2">Learning to fly from the best</div>
                    <div class="howto-text">
                        Located in the stunning Gisborne region, on the banks of the Te Arai River, Millton proudly states that it is the first vineyard to practice organic and biodynamic farming in the country. Established in 1984, James and Annie Millton need no introduction. Annie’s father, John Clark,
                        was a forerunner in establishing vineyards in New Zealand, having planted vines as far back as
                        1967. As a young couple, James and Annie travelled to Europe to gain some experience in the
                        business, cutting their teeth in prestigious estates such as Champagne Bollinger, Maison Sichel
                        in Bordeaux and Weingut Kurstner in Rheinhessen. Upon their return to NZ, they replanted much of
                        Clark’s estate (which was more of a grape growing business at the time), and hey presto, Millton
                        Vineyards and Winery was born.
                    </div>

                    <div class="howto-title2">Four labels</div>
                    <div class="howto-text">
                        Since Milton’s inception, the Milltons have planted two more vineyards and today they produce
                        varietals of Chardonnay, Pinot Noir, Syrah, Gewurztraminer and Riesling under four main labels.
                        Of these, their signature Millton range is the best expression of their forty years of
                        evolution, and both the Pinot Noir and the Reisling are high scorers at 90 points on aggregate
                        in general (93 from Huon Hook for 2011s Pinot Noir). As with most new world wines, pricing is
                        ridiculously low, think just €20 on average.
                        <br><br>
                        While investing in new world fine wines remains something of a grey area for now, Millton’s
                        heritage, savoir-faire, farming practices and low-yields go a long way in placing them at the
                        top of the list when the time is right. Which could be even now.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MilltonVineyardsAndWinery",
    data() {
        return {
            select: {
                report: 'Millton Vineyards and Winery',
                src: '/wine-guide/new-zealand/millton-vineyards-and-winery'
            },
            items: [
                {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
                {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
                {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
                {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
                {report: 'Millton Vineyards and Winery', src: '/wine-guide/new-zealand/millton-vineyards-and-winery'},
                {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
                {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
                {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Millton Vineyards and Winery | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wine production of Millton Vineyards and Winery, one of New Zealand\'s leading winemakers. Experience their unique blend of traditional and modern winemaking techniques.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
